export const AWS_CONFIG = {
  region: 'ap-southeast-1',
  userPoolId: 'ap-southeast-1_RhLjDifw7',
  userPoolWebClientId: '207s2bclnb3k07umu3o3v111af',
};
